export default __webpack_public_path__ + "static/media/telegram.704f0321.png";